import * as React from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> { }

const ArrowDown: React.FC<SVGProps> = (props) => (
    <svg
        width={14}
        height={27}
        viewBox="0 0 14 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.91493 25.0229L6.91493 1.66992M6.91493 25.0229L1.72537 19.8334M6.91493 25.0229L12.1045 19.8334"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ArrowDown;



export const AddCircleIcon: React.FC<SVGProps> = (props) => (
    <svg
        width={26}
        height={26}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7324 24.0353C6.76727 24.0353 1.93163 19.1981 1.93163 13.2346C1.93163 7.27101 6.76727 2.43383 12.7324 2.43383C18.6974 2.43383 23.5331 7.27101 23.5331 13.2346C23.5331 19.1981 18.6974 24.0353 12.7324 24.0353ZM12.7324 0.890869C5.91479 0.890869 0.388672 6.41467 0.388672 13.2346C0.388672 20.0544 5.91479 25.5782 12.7324 25.5782C19.5499 25.5782 25.076 20.0544 25.076 13.2346C25.076 6.41467 19.5499 0.890869 12.7324 0.890869ZM17.3612 12.4631H13.5038V8.60567C13.5038 8.18136 13.159 7.83419 12.7324 7.83419C12.3057 7.83419 11.9609 8.18136 11.9609 8.60567V12.4631H8.10348C7.67685 12.4631 7.332 12.8102 7.332 13.2346C7.332 13.6589 7.67685 14.006 8.10348 14.006H11.9609V17.8634C11.9609 18.2878 12.3057 18.6349 12.7324 18.6349C13.159 18.6349 13.5038 18.2878 13.5038 17.8634V14.006H17.3612C17.7879 14.006 18.1327 13.6589 18.1327 13.2346C18.1327 12.8102 17.7879 12.4631 17.3612 12.4631Z"
            fill="white"
        />
    </svg>
);

